import React, { useEffect, Suspense, lazy } from 'react';
import { AnnouncementBar, Navbar, HeroSection } from './components/TopSections';
import { ScrollReveal } from './components/Overlays';
import { initPixel, trackEvent } from './utils/pixel';
// Lazy load all below-fold sections
const LazyPainSection = lazy(() => import('./components/TopSections').then(m => ({
  default: m.PainSection
})));
const LazyMamaResultsSection = lazy(() => import('./components/TopSections').then(m => ({
  default: m.MamaResultsSection
})));
const LazyValueStackSection = lazy(() => import('./components/MiddleSections').then(m => ({
  default: m.ValueStackSection
})));
const LazyOrderBumpsSection = lazy(() => import('./components/BottomSections').then(m => ({
  default: m.OrderBumpsSection
})));
const LazyGuaranteeSection = lazy(() => import('./components/BottomSections').then(m => ({
  default: m.GuaranteeSection
})));
const LazyWhatsAppTestimonialsSection = lazy(() => import('./components/BottomSections').then(m => ({
  default: m.WhatsAppTestimonialsSection
})));
const LazyFAQSection = lazy(() => import('./components/BottomSections').then(m => ({
  default: m.FAQSection
})));
const LazyFinalCTASection = lazy(() => import('./components/BottomSections').then(m => ({
  default: m.FinalCTASection
})));
const LazyFooterSection = lazy(() => import('./components/BottomSections').then(m => ({
  default: m.FooterSection
})));
const LazySocialProofToast = lazy(() => import('./components/Overlays').then(m => ({
  default: m.SocialProofToast
})));
export function App() {
  useEffect(() => {
    initPixel();
    trackEvent('PageView');
  }, []);
  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => e.preventDefault();
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'F12' || e.ctrlKey && e.key === 'u') {
        e.preventDefault();
      }
    };
    document.addEventListener('contextmenu', handleContextMenu);
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []);
  return <div className="min-h-screen bg-[#FDF9F3] antialiased" data-id="element-0">
      <div className="h-[36px] sm:h-[40px]" data-id="element-1" />
      <AnnouncementBar data-id="element-2" />
      <Navbar data-id="element-3" />

      <main data-id="element-4">
        {/* Hero — above fold, no lazy, no scroll reveal */}
        <HeroSection data-id="element-5" />

        <Suspense fallback={null} data-id="element-6">
          <ScrollReveal data-id="element-7">
            <LazyPainSection data-id="element-8" />
          </ScrollReveal>

          <ScrollReveal data-id="element-9">
            <LazyMamaResultsSection data-id="element-10" />
          </ScrollReveal>

          <ScrollReveal data-id="element-11">
            <LazyValueStackSection data-id="element-12" />
          </ScrollReveal>

          <ScrollReveal data-id="element-13">
            <LazyOrderBumpsSection data-id="element-14" />
          </ScrollReveal>

          <ScrollReveal data-id="element-15">
            <LazyGuaranteeSection data-id="element-16" />
          </ScrollReveal>

          <ScrollReveal data-id="element-17">
            <LazyFinalCTASection data-id="element-18" />
          </ScrollReveal>

          <ScrollReveal data-id="element-19">
            <LazyWhatsAppTestimonialsSection data-id="element-20" />
          </ScrollReveal>

          <ScrollReveal data-id="element-21">
            <LazyFAQSection data-id="element-22" />
          </ScrollReveal>
        </Suspense>
      </main>

      <Suspense fallback={null} data-id="element-23">
        <LazyFooterSection data-id="element-24" />
        <LazySocialProofToast data-id="element-25" />
      </Suspense>
    </div>;
}